import { render, staticRenderFns } from "./aviatrix.vue?vue&type=template&id=1f493010"
import script from "./aviatrix.vue?vue&type=script&lang=js"
export * from "./aviatrix.vue?vue&type=script&lang=js"
import style0 from "./aviatrix.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/aviatrix.vue
// module id = kxCt
// module chunks = 0